import { diContainer, serviceNames } from '../../diContainer/diContainer';
import TransactionRepository from './TransactionRepository';

/*
  Higher order function to mark the transaction as dirty on any function that is known to delegate a transaction update
*/
export function markDirtyTransaction() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (_target: any, _propertyKey: string, descriptor: TypedPropertyDescriptor<(... params: any[])=> Promise<any>>) => {
    const oldFunc = descriptor.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    descriptor.value = async function (...args: any[]) {
      const result = await oldFunc?.apply(this, args);

      const transactionRepository: TransactionRepository = diContainer.get(serviceNames.transactionRepository);
      transactionRepository.transaction.setIsDirty(true);

      return result;
    };
  };
}